import React from 'react'

import img1 from './img/dabski1.jpg'
import img2 from './img/dabski1.jpg'
import img3 from '/web frontend/projekty React/oldboy/src/img/dabski1.jpg'

import iii3 from '../opis/img/dabski1.jpg'



function opisDabski() {
  return (
    <div className='opis-container'>
      <div className='opis-header'>
        
        <h1>Grębałowianka - Dąbski</h1> 
        
       
      </div>

      <div className='opis-info'>
          <p>2 kolejka I ligi oldboyów Kraków <br></br>

          Grębałowianka Kraków -Dąbski Kraków 5:1 (2:0) <br></br>
          Bramki dla Gręby: 1:0 Cecuga as. Oleś, 2:0 Lampart as. Strojek R, 3:0 Cecuga as Wierzbinski , 4:0 Franaszek b/a, 5:0 Strojek R karny po faulu na Cecuga <br></br>

          Skład Grębałowianki: Nowak - Towarek, Dominik, Korcala, Wierzbinski, Strojek G, Oleś, Lampart, Mucharski, Cecuga, Strojek R - Zięba, Grzywa, Talaga, Zawada, Sendor, Kawula , Franaszek  <br></br>
          Trener: Bernard Łach 
          Kapitan: Piotr Kokosza 
          Stolarski, Wójcik, Krawczyk,Tynor 

          2 kolejka rywal beniaminek rozgrywek Dąbski Kraków.
          I połowa pod dyktando gospodarzy. Jedna z pierwszych akcji ładne podanie Olesia do Cecugi a ten ładnym wejściem w pole karne kończy akcję strzałem po krótkim rogu. Kolejne akcje mnożyły się dla gospodarzy.Lampart pięknym rajdem wypuszczony w uliczkę przez Strojka kończy bramką na 2:0. Pozostałe aukcje pierwszej połowy nie wykorzystali Strojek R, Cecuga, Lampart. Druga połowa to konsekwencja mądrej gry z tyłu i szybkie kontrataki. 3:0 to ładna bramka Cecugi po różnym Wierzbinskiego . Goście próbowali szczęścia kilkukrotnie strzelając ale na posterunku stał Nowak. 4:0 to inwidualna akcja Franaszka bramka dająca już spokój w szeregach gospodarzy. Pod koniec spotkania Strojek R strzelając karnego ustalił wynik strzelając 5 bramkę po faulu na Cecuga. Honorowe trafienie dla gości to efekt rozluźnienia w szeregach Gręby i wynik ustalony na 5:1 dla Grębałowianki. Brawo dla całej drużyny za przybycie, walkę i determinację.
          Słowo trenera B.Łacha 
          Brawo dla całej drużyny. Dzięki chłopaki. Razem dla KSG. 
          Konsekwencja defensywna, jakość gry, umiejętne stosowanie arytmii, kreacja ofensywna, gole zwycięskie.⚽👍👏
          Za tydzień 3 kolejka gramy mecz z Borkiem Kraków na wyjeździe.

          Pozdrawiam Piotr Grzywa 😉 👌⚽
          
          </p>

        <img src={iii3} alt='gre-dab'></img>
        <img src={img2} alt='gre-dab'></img>
        <img src={img3} alt='gre-dab'></img>
        
       
      </div>
        
        </div>
  )
}

export default opisDabski